import { Component, OnInit } from '@angular/core';
import { OrganizationInfo } from "src/app/model/organization";
import { Input } from "@angular/core";
import { RegistrationService } from "src/app/services/registration.servcie";
import { FileUploadService } from "src/app/services/fileupload.service";
import { Router } from "@angular/router";
import { ViewChild } from "@angular/core";
import { ElementRef } from "@angular/core";
import { OrganizationFiles } from '../model/organizationfiles';
import { SpinnerService } from '../spinner/spinner.service';
import { CommonService } from "src/app/services/common.service";
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

declare function invokeFailToastr(title,message);
declare function invokeSuccessToastr(title,message);
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent implements OnInit {

// @ViewChild('inputinsfile') 
//   public myInputInsVariable: ElementRef;

//   @ViewChild('inputFile') 
//   public myInputVariable: ElementRef;
public organizationFiles: OrganizationFiles;
public disableSubmit: boolean = false;
public selectedFiles: FileList;
public selectedInsFiles: FileList;
public yccFiles: any;
private _organizationInfo: OrganizationInfo;

  captchaResponse: any;
 declarativeFormCaptchaValue: any;
  
 @ViewChild('reviewForm')
  public reviewForm: NgForm;

 @Input()
  public get organizationInfo(): OrganizationInfo { return this._organizationInfo; }
  public set organizationInfo(v: OrganizationInfo) { this._organizationInfo = v; }
  
  constructor(private readonly _registrationService: RegistrationService,
  private _fileUploadService: FileUploadService,
  private readonly _router: Router,
  private _commonService: CommonService,
  private readonly _spinner: SpinnerService) {
    this.yccFiles = [];
   }

  ngOnInit() {
  }

resolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
    console.log(`Resolved captcha with response ${captchaResponse}:`);
  }

  public resetinputFileCtl() {
    //this.myInputVariable.nativeElement.value = '';
     $("#inputFile").val("");
}

  public resetinsinputFileCtl() {
   // this.myInputInsVariable.nativeElement.value = '';
      $("#inputinsfile").val("");
}

public RemoveLogoFile () {
 this.organizationInfo.IsLogoUploaded = false;
}
  public selectFile(event) { 
    console.log(event);

if (!this.isFileAcceptable(event.target.files[0], 'Logo')) {
  this.resetinputFileCtl();
            event.preventDefault(); 
        }
        else {

      this.selectedFiles = event.target.files;
      if(this.selectedFiles.length > 0) {
        for (let i = 0; i < this.selectedFiles.length ; i++) {
          const file = this.selectedFiles.item(i);
          console.log(file);
          const awsFileGuid = this.guid();
          let data = {
            AwsFileGuid: awsFileGuid,
            fileTypeDescription: 'Logo',
            filename: file.name,
            filesize: file.size,
            file: file,
            filetype: file.type,
            filemetadata: ''
        };
        console.log(data);
        this.yccFiles.push(data);
        if (this.findArrIndex(this.yccFiles, 'fileTypeDescription', 'Logo') > -1) {
          this.organizationInfo.IsLogoUploaded = true;
        } 
      }
      }
    }     
  }

public RemoveInsFile () {
  this.organizationInfo.IsInsuranceLoaded = false;
}
 public selectInsFile(event) { 
    console.log(event);

if (!this.isFileAcceptable(event.target.files[0], 'Insurance')) {
   this.resetinsinputFileCtl();
            event.preventDefault(); 
        }
        else {
      this.selectedInsFiles = event.target.files;
      if(this.selectedInsFiles.length > 0) {
        for (let i = 0; i < this.selectedInsFiles.length ; i++) {
          const file = this.selectedInsFiles.item(i);
          console.log(file);
          const awsFileGuid = this.guid();
          let data = {
            AwsFileGuid: awsFileGuid,
            fileTypeDescription: 'Insurance',
            filename: file.name,
            filesize: file.size,
            file: file,
            filetype: file.type,
            filemetadata: ''
        };
        console.log(data);
        this.yccFiles.push(data);
        if (this.findArrIndex(this.yccFiles, 'fileTypeDescription', 'Insurance') > -1) {
          this.organizationInfo.IsInsuranceLoaded = true;
      } 
      }
    }
        }           
  }

private getSubject (fileName) {
  let index = fileName.lastIndexOf('.');
  let filenamewithoutextension = fileName.substr(0, index);

  return filenamewithoutextension;
}

  public guid  () {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
        this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }
    public s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

public getSelectedResources(resources) {
 return Array.prototype.map.call(resources, function(item) { return item.Value; }).join(", "); 
}

public getSelectedLanguages(languages) {
 // return Array.prototype.map.call(languages, s => s.Value).toString();
 return Array.prototype.map.call(languages, function(item) { return item.Value; }).join(", "); 
}

public getSelectedAgeTypes(ageTypes) {
 // return Array.prototype.map.call(languages, s => s.Value).toString();
 return Array.prototype.map.call(ageTypes, function(item) { return item.Value; }).join(", "); 
}

public findArrIndex (arr, colName, value) {
    let index = -1;
    let comArr = eval(arr);

    if (value !== null) {
        for (let i = 0; i < comArr.length; i++) {
            if (comArr[i][colName] === value) {
                index = i;
                break;
            }
        }
    }
    return index;
}

  public saveAgencyDetails () {
    let that = this;
    that._spinner.show();
    const element = document.querySelector('#screentop');
    element.scrollIntoView();
    that.disableSubmit = true;
    if(!(that.organizationInfo.OrganizationGuid != undefined &&
      that.organizationInfo.OrganizationGuid != '')) {
        that.organizationInfo.OrganizationGuid = this.guid();  
        that.organizationInfo.Status = 'New';
      }
   

if ((that.organizationInfo.InsuranceNumber != undefined && that.organizationInfo.InsuranceNumber != '' ) ||
       (that.organizationInfo.InsuranceCompanyName != undefined && that.organizationInfo.InsuranceCompanyName != '' ) ||
       (that.yccFiles != undefined && that.yccFiles.length > 0 && this.findArrIndex(that.yccFiles, 'fileTypeDescription', 'Insurance') > -1)) {
          that.organizationInfo.IsInsuranceLoaded = true;
          if(that.yccFiles != undefined && that.yccFiles.length > 0 && this.findArrIndex(that.yccFiles, 'fileTypeDescription', 'Insurance') > -1) {
            that.organizationInfo.InsuranceFileName = that.selectedInsFiles.item(0).name;
          }
      } else {
        that.organizationInfo.IsInsuranceLoaded = false;
      }
   
    if(that.yccFiles != undefined && that.yccFiles.length > 0) {

      // if (this.findArrIndex(that.yccFiles, 'fileTypeDescription', 'Insurance') > -1 ||
      //  (that.organizationInfo.InsuranceNumber != undefined && that.organizationInfo.InsuranceNumber != '' ) ||
      //  (that.organizationInfo.InsuranceCompanyName != undefined && that.organizationInfo.InsuranceCompanyName != '' )) {
      //     that.organizationInfo.IsInsuranceLoaded = true;
      //     that.organizationInfo.InsuranceFileName = that.selectedInsFiles.item(0).name;
      // } else {
      //   that.organizationInfo.IsInsuranceLoaded = false;
      // }
      if (this.findArrIndex(that.yccFiles, 'fileTypeDescription', 'Logo') > -1) {
          that.organizationInfo.IsLogoUploaded = true;
          that.organizationInfo.LogoFileName = that.selectedFiles.item(0).name;
      } else {
         that.organizationInfo.IsLogoUploaded = false;
      }
    }
    console.log('Request: ' + JSON.stringify(that.organizationInfo));
    //that._fileUploadService.uploadFiles(this.yccFiles, this.organizationInfo.OrganizationGuid);
     that._registrationService.newRegistration(this.organizationInfo).subscribe((result) => {
      console.log(result);
      that._spinner.hide();
      if(result != undefined && result != 'ERROR') {
            that._fileUploadService.uploadFiles(this.yccFiles, this.organizationInfo.OrganizationGuid);
            invokeSuccessToastr('Successfully Submitted', 'The application has been successfuly submitted to DA.');
            that.disableSubmit = false;
            this._commonService.resetForm(true);
            this.reviewForm.form.markAsPristine();
            that._router.navigate(['app-confirmation']);
      } else {
        invokeFailToastr('Failed',
              'Something went wrong and the application has not be submitted. Please try again.');
               that._router.navigate(['error']);
      }
      
    }, (err) => {
      console.log(err);
       invokeFailToastr('Failed',
              'Something went wrong and the application has not be submitted. Please try again.');
               that._router.navigate(['error']);
    });
  }

  private isFileAcceptable (file, type) {
  let extension = this.getFileExtention(file.name);
  
  if (type == 'Logo' && ( extension.toLowerCase() === 'png' || extension.toLowerCase() === 'jpg' || extension.toLowerCase() === 'jpeg')) {
        return true;
      }
  else if (type == 'Insurance' && extension.toLowerCase() === 'pdf') {
        return true;
      }

  // for (let i = 0, len = this.fileExtensionLookup.length; i < len; i++) {
  //   if (extension.toLowerCase() === this.fileExtensionLookup[i].Code.toLowerCase()) {
  //       return true;
  //     }
  //   }
  return false;
}
private getFileExtention (fileName) {
  let i = fileName.lastIndexOf('.');
  if (i === -1) {
    return false;
  }
  return fileName.slice(i + 1);
}

private getOrganizationData(){
}

public isReadyToSubmit (isForminValid) {

  if((!isForminValid &&    
   this.organizationInfo.IsLogoUploaded) ||
   !this.disableSubmit) {
     return true;
   } else {
     return false;
   }
}

public Initialize() {

  if(this.organizationInfo.OrganizationGuid != undefined && this.organizationInfo.OrganizationGuid != '') {
    this.getUploadedFiles(this.organizationInfo.OrganizationGuid);
  }
}
public getUploadedFiles (orgGuid) {
  let that = this;
  this._registrationService.getOrganizationFileUrls(orgGuid).subscribe((filesresult) => {
    console.log(filesresult);
    if(filesresult != undefined && filesresult != 'ERROR') {
        that.organizationFiles = filesresult;
    }

  }, (fileserr) => {
    console.log(fileserr);
  });
}
}
